<otb-warning></otb-warning>
<div class="row">
    <div class="col-12">
        <p class="addition">
            <span
                [innerHTML]="'dynamische_frontend_texte.landing.html_content.ueberschrift' | translate | safeStyle"
            ></span>
        </p>
    </div>
    <otb-progress-bar></otb-progress-bar>
</div>
<form id="agency-service-selection" [formGroup]="agencyFormGroup" (ngSubmit)="onSubmit()">
    <div class="row align-items-end">
        <div class="col-12 mb-4">
            @if (environment.deploy_environment === deployEnv.MAGS_SOP) {
                <h1
                    class="landing-intro"
                    [innerHTML]="'dynamische_frontend_texte.landing.html_content.einfuehrung' | translate | safeStyle"
                ></h1>
            } @else {
                <h2
                    class="landing-intro"
                    [innerHTML]="'dynamische_frontend_texte.landing.html_content.einfuehrung' | translate | safeStyle"
                ></h2>
            }
        </div>
        <div class="col-12 col-sm-6">
            <div class="form-group">
                <otb-agency-selection
                    [agencyFormGroup]="agencyFormGroup"
                    (agencyChange)="onAgencySelect($event)"
                ></otb-agency-selection>
            </div>
        </div>
        <div class="col-12 col-sm-6">
            <div class="form-group">
                <label
                    for="citizen-service"
                    id="citizen-service-label"
                    [innerHTML]="
                        'dynamische_frontend_texte.landing.html_content.label_dropdown_leistung'
                            | translate
                            | required
                            | safeStyle
                    "
                ></label>
                <ng-select
                    id="citizen-service"
                    [items]="servicesSelect"
                    bindLabel="name"
                    bindValue="id"
                    (change)="onServiceSelect($event)"
                    formControlName="service"
                    [clearable]="false"
                    [markFirst]="false"
                    placeholder="Dienstleistung auswählen"
                    [loading]="serviceSelectionAjaxLoading"
                    [loadingText]="'Dienstleistungen werden geladen...'"
                    notFoundText="Keine Einträge gefunden"
                    [inputAttrs]="{
                        'aria-describedby': 'citizen-service-error citizen-service-hint',
                        'aria-labelledby': 'citizen-service-label',
                    }"
                    dropdownCustomHoverColorDirective
                    otbAnnounceSearchResults
                ></ng-select>
                <span id="citizen-service-hint" class="visually-hidden">
                    {{ 'dynamische_frontend_texte.landing.attribute_text.hinweis_fokus_leistung' | translate }}
                </span>
                <otb-form-error-message
                    id="citizen-service-error"
                    [show]="formService.invalid && formService.dirty"
                ></otb-form-error-message>
            </div>
        </div>
        <div [ngClass]="envCssClassesGenerator.serviceNoticeClasses">
            @if (selectedService) {
                <div class="service-notice" [ngClass]="isEnvJustice ? 'mt-5' : 'mt-3'">
                    @if (hasServiceNotice) {
                        <section class="row">
                            @if (environment.deploy_environment === deployEnv.MAGS_SOP) {
                                <h2
                                    #serviceNoticeHeading
                                    id="service-notice-heading"
                                    class="description-title"
                                    tabindex="-1"
                                    [innerHTML]="
                                        'dynamische_frontend_texte.landing.html_content.zusaetzliche_informationen'
                                            | translate
                                            | safeStyle
                                    "
                                ></h2>
                            } @else {
                                <h3
                                    #serviceNoticeHeading
                                    id="service-notice-heading"
                                    class="description-title"
                                    tabindex="-1"
                                    [innerHTML]="
                                        'dynamische_frontend_texte.landing.html_content.zusaetzliche_informationen'
                                            | translate
                                            | safeStyle
                                    "
                                ></h3>
                            }
                            <div
                                class="notice-text"
                                [ngClass]="isEnvJustice ? 'mt-4' : 'mt-2'"
                                [innerHTML]="selectedService.notice | safeStyle"
                            ></div>
                            @if (selectedService.url !== '') {
                                <p>
                                    <span
                                        [innerHTML]="
                                            'dynamische_frontend_texte.landing.html_content.url' | translate | safeStyle
                                        "
                                    ></span>
                                    <a
                                        class="ms-1"
                                        [href]="selectedService.url"
                                        [innerHTML]="selectedService.url"
                                        [attr.aria-label]="
                                            selectedService.url +
                                            ' - ' +
                                            ('dynamische_frontend_texte.barrierefreiheit.attribute_text.externe_url_aria_label'
                                                | translate)
                                        "
                                        target="_blank"
                                    ></a>
                                </p>
                            }
                        </section>
                    }
                    <div class="form-group d-flex justify-content-end">
                        <button
                            type="submit"
                            class="btn-success btn rounded-0"
                            accesskey="w"
                            btnPrimaryColorDirective
                            [innerHTML]="'dynamische_frontend_texte.shared.button.next' | translate | safeStyle"
                        ></button>
                    </div>
                </div>
            }
        </div>
    </div>
</form>
